/**
 * Integration Logo Utility
 *
 * Logo URLs are managed via integration listings (uploaded to Galactus).
 * This file provides a letter-avatar fallback for cases where the image
 * fails to load at runtime.
 */

const DEFAULT_AVATAR_COLOR = "#6366F1";

export function getLetterAvatar(name: string, color?: string): string {
   const letter = name
      .charAt(0)
      .toUpperCase()
      .replaceAll(/[<>&"']/g, "");
   const bgColor = color || DEFAULT_AVATAR_COLOR;
   return `data:image/svg+xml,${encodeURIComponent(
      `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40"><rect fill="${bgColor}" width="40" height="40" rx="8"/><text x="20" y="26" font-family="system-ui,sans-serif" font-size="18" font-weight="600" fill="white" text-anchor="middle">${letter}</text></svg>`
   )}`;
}
